export default __webpack_public_path__ + "static/media/herzlich-new1.f6aa1075.png";